import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MissionService } from '../../../../services/mission.service';
import { AuthService } from '../../../../services/auth.service';
import { FlagService } from '../../../../shared/services/flag.service';
import { FlagType, MissionStatusEnum } from '../../../../shared/utils/enums';

@Component({
  selector: 'app-missions-rejected',
  templateUrl: './missions-rejected.component.html',
  styleUrl: './missions-rejected.component.scss',
})
export class MissionsRejectedComponent implements OnInit {
  loading = false;
  formGroup: FormGroup = this.fb.group({
    comment: [''],
    motifsRefus: ['', Validators.required],
  });
  show: boolean = false;
  reasonArray = [
    {
      value: 'Le (La) candidat(e) était absent(e)',
      label: 'Le (La) candidat(e) était absent(e)',
    },
    {
      value:
        'Le (La) candidat(e) s’est présenté(e) avec un retard important et n’a pas effectué sa mission.',
      label:
        'Le (La) candidat(e) s’est présenté(e) avec un retard important et n’a pas effectué sa mission.',
    },
    {
      value:
        'Le (La) candidat(e) a été responsable d’un accident grave ayant nécessité l’interruption de la mission.',
      label:
        'Le (La) candidat(e) a été responsable d’un accident grave ayant nécessité l’interruption de la mission.',
    },
    {
      value:
        'Le (La) candidat(e) a eu un problème de comportement grave ayant nécessité l’interruption de la mission.',
      label:
        'Le (La) candidat(e) a eu un problème de comportement grave ayant nécessité l’interruption de la mission.',
    },
    {
      value:
        'Le (La) candidat(e) a eu un problème de compétence ayant nécessité l’interruption de la mission.',
      label:
        'Le (La) candidat(e) a eu un problème de compétence ayant nécessité l’interruption de la mission.',
    },
    { value: 'Autre cause', label: 'Autre cause' },
  ];
  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) private data: any,
    public dialogRef: MatDialogRef<MissionsRejectedComponent>,
    private missionService: MissionService,
    private auth: AuthService,
    private flag: FlagService
  ) {

  }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
  }

  rejectEvaluation() {
    this.loading = true;
    const body = {
      ...this.formGroup.value,
      candidatFullname: this.data.candidat.candidateName,
      enddate: this.data.mission.enddate,
      startdate: this.data.mission.startdate,
      // The establishment owning the mission (an agency admin's own id is not an establishment id -> FK violation).
      etablissementId: this.data.mission.etablissementId ?? this.auth.id,
      serviceAffectation: this.data.mission.typePoste,
      missionId: this.data.mission.id,
      missionStatus: MissionStatusEnum.INVALIDATED,
      rating: 0,
    };
    this.missionService.rejectMission(body).subscribe({
      next: (value) => {
        this.loading = false;
        this.flag.displayFlag('Votre refus de validation est confirmé.', FlagType.success);
        this.dialogRef.close();
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  protected readonly indexedDB = indexedDB;
}
